export interface DictItem {
    code: string;
    name: string;
}

export interface CitySuggestion {
    value: string;
    data?: {
        city_fias_id?: string;
        settlement_fias_id?: string;
        kladr_id?: string;
    };
}

// House-флаги объекта (welcome → A4317 whitelist). Имена ключей совпадают с
// тем, что A4317 принимает в payload (см. поток A-pay / контракт Tier C).
export interface HouseFlags {
    no_loan_agreement: boolean;
    no_property_rights: boolean;
    has_wooden_floors: boolean;
    has_gas_supply: boolean;
}

export const HOUSE_FLAG_FIELDS: { key: keyof HouseFlags; label: string }[] = [
    { key: 'no_loan_agreement', label: 'Кредитный договор ещё не заключён' },
    { key: 'no_property_rights', label: 'Право собственности ещё не оформлено' },
    { key: 'has_wooden_floors', label: 'Деревянные перекрытия' },
    { key: 'has_gas_supply', label: 'Газоснабжение в доме' },
];

// Допустимый диапазон возраста страхователя на шаге 1 (A2). Ранняя клиентская
// подсказка: бэкенд остаётся fail-closed (СК отсеют по возрасту на расчёте),
// но мы предупреждаем юзера до перехода, чтобы он не упёрся в пустую выдачу.
// Диапазон зависит от типа страхования: страхование жизни СК принимают в более
// узком возрастном окне, чем имущество.
export interface AgeRange {
    min: number;
    max: number;
}

// Продукты со страхованием жизни (product_code содержит «Life»: 'Life',
// 'LifeAndProperty', …) — узкое окно. Прочие (имущество, титул) — широкое.
export const AGE_RANGE_LIFE: AgeRange = { min: 18, max: 65 };
export const AGE_RANGE_DEFAULT: AgeRange = { min: 18, max: 85 };

// product_code приходит из справочника в PascalCase ('Property',
// 'LifeAndProperty', 'Life'). Признак страхования жизни — наличие подстроки
// «life» в коде.
export function isLifeProduct(productCode?: string): boolean {
    return !!productCode && productCode.toLowerCase().includes('life');
}

export function ageRangeFor(productCode?: string): AgeRange {
    return isLifeProduct(productCode) ? AGE_RANGE_LIFE : AGE_RANGE_DEFAULT;
}
